"use client";

import React from "react";
import { SessionProvider } from "next-auth/react";

/**
 * AuthProvider component to wrap the application with NextAuth's SessionProvider
 * This makes the session data available throughout the app
 */
export function AuthProvider({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider 
      // Refetch session every hour to ensure token stays valid
      refetchInterval={60 * 60}
      // Don't refetch session on window focus to avoid unnecessary requests
      refetchOnWindowFocus={false}
    >
      {children}
    </SessionProvider>
  );
}
